<template>
    <div class="paces" id="slider">
        <div class="pace" v-for="unit in units">
            <h5 class="pace-title"><span class="locked" v-if="unit.status == 1"></span>{{ unit.name }}</h5>
            <div class="pace-item">
                <ul class="pace-line">
                    <li class="d-flex flex-column justify-content-center align-items-center" v-for="lesson in unit.lessons">
                        <p class="text-nowrap">{{ lesson.name }}</p>
                        <i class="pace-item-status" :class="{ completed: lesson.total > 0 && lesson.process == lesson.total, unlocked: lesson.total > 0 && lesson.process < lesson.total, locked: lesson.total == 0 || lesson.status != 0 }"></i>
                        <p class="text-nowrap">{{ moment.unix(lesson.pacing_end_time).format('Do, MMM') }}</p>
                    </li>
                </ul>
                <div class="pace-reward" :class="pacing_status[unit.pacing_status]" @click="$emit('viewPacing', unit)">
                    <i class="pace-reward-noti heartbeat" v-if="unit.pacing_status == 1"></i>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "Pace",
    components: {},
    props: ['units'],
    data() {
        return {
            pacing_status: ['disabled', 'clamable', 'clamed', 'expired'],
        }
    },
    mounted() {
        const slider = document.querySelector('#slider');
        let isDown = false;
        let startX;
        let startY;
        let scrollLeft;
        let scrollTop;
        if (slider) {
            slider.addEventListener("wheel", (e) => {
                e.preventDefault();
                const walk = e.deltaY * 1;
                slider.scrollLeft += walk;
            })
            slider.addEventListener('mousedown', (e) => {
                isDown = true;
                slider.classList.add('active');
                startX = e.pageX - slider.offsetLeft;
                startY = e.pageY - slider.offsetTop;
                scrollLeft = slider.scrollLeft;
                scrollTop = slider.scrollTop;
            });
            slider.addEventListener('mouseleave', () => {
                isDown = false;
                slider.classList.remove('active');
            });
            slider.addEventListener('mouseup', () => {
                isDown = false;
                slider.classList.remove('active');
            });

            slider.addEventListener('mousemove', (e) => {
                if (!isDown) return;
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                const x = e.pageX - slider.offsetLeft;
                const y = e.pageY - slider.offsetTop;
                const walk = (x - startX) * 1;
                const walktop = (y - startY) * 1;
                slider.scrollLeft = scrollLeft - walk;
                slider.scrollTop = scrollTop - walktop;
            });
        }
    },
};
</script>

<style scoped>
.paces-wrapper {
    width: 100%;
    height: 126px;
    display: flex;
    position: relative;
    border: 1px solid #DEDEDE;
    border-radius: 8px;
}

.paces-wrapper .paces-help {
    width: 24px;
    height: 24px;
    background: var(--primary);
    color: #FFFFFF;
    font-size: 16px;
    font-weight: 700;
    border-radius: 50%;
    overflow: hidden;
    position: absolute;
    top: -12px;
    right: -12px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.paces {
    width: 100%;
    padding: 12px 20px;
    display: flex;
    overflow-y: hidden;
    overflow-x: auto;
    gap: 10px;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
}

.pace {
    display: flex;
    flex-direction: column;
}

.pace-title {
    display: flex;
    font-size: 16px;
    line-height: 19.19px;
    font-weight: 700;
    gap: 3px;
}

.pace-title .locked {
    content: url('data:image/svg+xml,<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.7932 8.54508C13.596 7.88168 12.9442 7.22355 12.279 6.99504V4.59773C12.279 3.72164 11.9377 2.89793 11.3186 2.27918C10.6995 1.65938 9.87575 1.31836 8.99966 1.31836C7.19122 1.31836 5.72028 2.78965 5.72028 4.59773V6.99504C5.05513 7.22355 4.40333 7.88168 4.2061 8.54508C3.70864 10.5592 3.70864 12.5023 4.2061 14.5164C4.41282 15.2111 5.11841 15.9012 5.81556 16.0966C7.95376 16.5955 10.0456 16.5955 12.1838 16.0966C12.8809 15.9012 13.5865 15.2111 13.7932 14.5164C14.2907 12.5023 14.2907 10.5592 13.7932 8.54508ZM8.99966 2.44336C9.57517 2.44336 10.1162 2.6673 10.523 3.07477C10.9301 3.48152 11.154 4.02223 11.154 4.59773V6.76301C9.71298 6.53344 8.28634 6.53344 6.84528 6.76301V4.59773C6.84528 3.4098 7.81173 2.44336 8.99966 2.44336ZM9.85536 12.0136V13.4754C9.85536 13.9479 9.47216 14.3311 8.99966 14.3311C8.52716 14.3311 8.14396 13.9479 8.14396 13.4754V12.0136C7.60853 11.7134 7.24642 11.141 7.24642 10.4832C7.24642 9.51504 8.03146 8.73 8.99966 8.73C9.96786 8.73 10.7529 9.51504 10.7529 10.4832C10.7529 11.141 10.3908 11.7137 9.85536 12.0136Z" fill="%230D0D0C"/></svg>');
}

.pace-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
}

.pace-item .pace-line {
    position: relative;
    border: 1px solid #DEDEDE;
    border-radius: 8px;
    list-style-type: none;
    display: flex;
    gap: 20px;
    margin: 0;
    padding: 12px;
}

.pace-item .pace-line li {
    z-index: 1;
}

.pace-item .pace-line p {
    font-size: 12px;
    font-weight: 400;
    color: #0D0D0C
}

.pace-item .pace-line::before {
    position: absolute;
    top: calc(50% - 5px);
    left: 5%;
    content: "";
    width: 90%;
    height: 10px;
    background: #E7E7E7;
    border-radius: 5px;
}


.pace-item .pace-reward {
    position: relative;
    width: 90px;
    height: 65px;
    background-image: url("/public/themes/ito/images/paces/pace-chest-disabled.svg");
    background-repeat: no-repeat;
    background-size: contain;
}

.pace-item .pace-reward .pace-reward-noti {
    position: absolute;
    top: 10px;
    right: 10px;
    border-radius: 50%;
    content: "";
    width: 13px;
    height: 13px;
    background: #EA521C;

}

.pace-item .pace-reward.clamable,
.pace-item .pace-reward.expired {
    background-image: url("/public/themes/ito/images/paces/pace-chest.svg");
}

.pace-item .pace-reward.clamed {
    background-image: url("/public/themes/ito/images/paces/pace-chest-opened.svg");
}

.pace-item .pace-reward.disabled {
    background-image: url("/public/themes/ito/images/paces/pace-chest-disabled.svg");
}

.pace-item-status {
    content: '';
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: #DEDEDE;
}

.pace-item-status.completed {
    content: url('data:image/svg+xml,<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="9" cy="9" r="9" fill="%2398C93C"/><path d="M5 9.00049L6.45139 10.4519C7.17549 11.176 7.53755 11.538 7.97812 11.518C8.41869 11.4981 8.74647 11.1047 9.40205 10.318L13 6.00049" stroke="white" stroke-linecap="round"/></svg>');
}

.pace-item-status.unlocked {
    content: url('data:image/svg+xml,<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="9" cy="9" r="9" fill="%23A2A2A2"/><path d="M5 9.00049L6.45139 10.4519C7.17549 11.176 7.53755 11.538 7.97812 11.518C8.41869 11.4981 8.74647 11.1047 9.40205 10.318L13 6.00049" stroke="white" stroke-linecap="round"/></svg>');
}

.pace-item-status.locked {
    content: url('data:image/svg+xml,<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.7932 8.54508C13.596 7.88168 12.9442 7.22355 12.279 6.99504V4.59773C12.279 3.72164 11.9377 2.89793 11.3186 2.27918C10.6995 1.65938 9.87575 1.31836 8.99966 1.31836C7.19122 1.31836 5.72028 2.78965 5.72028 4.59773V6.99504C5.05513 7.22355 4.40333 7.88168 4.2061 8.54508C3.70864 10.5592 3.70864 12.5023 4.2061 14.5164C4.41282 15.2111 5.11841 15.9012 5.81556 16.0966C7.95376 16.5955 10.0456 16.5955 12.1838 16.0966C12.8809 15.9012 13.5865 15.2111 13.7932 14.5164C14.2907 12.5023 14.2907 10.5592 13.7932 8.54508ZM8.99966 2.44336C9.57517 2.44336 10.1162 2.6673 10.523 3.07477C10.9301 3.48152 11.154 4.02223 11.154 4.59773V6.76301C9.71298 6.53344 8.28634 6.53344 6.84528 6.76301V4.59773C6.84528 3.4098 7.81173 2.44336 8.99966 2.44336ZM9.85536 12.0136V13.4754C9.85536 13.9479 9.47216 14.3311 8.99966 14.3311C8.52716 14.3311 8.14396 13.9479 8.14396 13.4754V12.0136C7.60853 11.7134 7.24642 11.141 7.24642 10.4832C7.24642 9.51504 8.03146 8.73 8.99966 8.73C9.96786 8.73 10.7529 9.51504 10.7529 10.4832C10.7529 11.141 10.3908 11.7137 9.85536 12.0136Z" fill="%230D0D0C"/></svg>');
}



.heartbeat {
    -webkit-animation: heartbeat 1.5s ease-in-out infinite both;
    animation: heartbeat 1.5s ease-in-out infinite both;
}

@-webkit-keyframes heartbeat {
    from {
        -webkit-transform: scale(1);
        transform: scale(1);
        -webkit-transform-origin: center center;
        transform-origin: center center;
        -webkit-animation-timing-function: ease-out;
        animation-timing-function: ease-out;
    }

    10% {
        -webkit-transform: scale(0.91);
        transform: scale(0.91);
        -webkit-animation-timing-function: ease-in;
        animation-timing-function: ease-in;
    }

    17% {
        -webkit-transform: scale(0.98);
        transform: scale(0.98);
        -webkit-animation-timing-function: ease-out;
        animation-timing-function: ease-out;
    }

    33% {
        -webkit-transform: scale(0.87);
        transform: scale(0.87);
        -webkit-animation-timing-function: ease-in;
        animation-timing-function: ease-in;
    }

    45% {
        -webkit-transform: scale(1);
        transform: scale(1);
        -webkit-animation-timing-function: ease-out;
        animation-timing-function: ease-out;
    }
}

@keyframes heartbeat {
    from {
        -webkit-transform: scale(1);
        transform: scale(1);
        -webkit-transform-origin: center center;
        transform-origin: center center;
        -webkit-animation-timing-function: ease-out;
        animation-timing-function: ease-out;
    }

    10% {
        -webkit-transform: scale(0.91);
        transform: scale(0.91);
        -webkit-animation-timing-function: ease-in;
        animation-timing-function: ease-in;
    }

    17% {
        -webkit-transform: scale(0.98);
        transform: scale(0.98);
        -webkit-animation-timing-function: ease-out;
        animation-timing-function: ease-out;
    }

    33% {
        -webkit-transform: scale(0.87);
        transform: scale(0.87);
        -webkit-animation-timing-function: ease-in;
        animation-timing-function: ease-in;
    }

    45% {
        -webkit-transform: scale(1);
        transform: scale(1);
        -webkit-animation-timing-function: ease-out;
        animation-timing-function: ease-out;
    }
}

.shake-top {
    -webkit-animation: shake-top 1.6s cubic-bezier(0.455, 0.030, 0.515, 0.955) infinite both;
    animation: shake-top 1.6s cubic-bezier(0.455, 0.030, 0.515, 0.955) infinite both;
    animation-delay: 0.8s;
}

@-webkit-keyframes shake-top {

    0%,
    25%,
    100% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
        -webkit-transform-origin: 50% 0;
        transform-origin: 50% 0;
    }

    5% {
        -webkit-transform: rotate(2deg);
        transform: rotate(2deg);
    }

    10% {
        -webkit-transform: rotate(-4deg);
        transform: rotate(-4deg);
    }

    15% {
        -webkit-transform: rotate(4deg);
        transform: rotate(4deg);
    }

    20% {
        -webkit-transform: rotate(-2deg);
        transform: rotate(-2deg);
    }
}

@keyframes shake-top {

    0%,
    50%,
    100% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
        -webkit-transform-origin: 50% 0;
        transform-origin: 50% 0;
    }

    5%,
    45% {
        -webkit-transform: rotate(2deg);
        transform: rotate(2deg);
    }

    10%,
    20%,
    30% {
        -webkit-transform: rotate(-4deg);
        transform: rotate(-4deg);
    }

    15%,
    25%,
    35% {
        -webkit-transform: rotate(4deg);
        transform: rotate(4deg);
    }

    40% {
        -webkit-transform: rotate(-2deg);
        transform: rotate(-2deg);
    }


}
</style>